import Navigation from '../componets/Navigation'
import Footer from '../componets/Footer'

function IntencjeLowiczki() {
    return(
        <>
            <Navigation />
            <div className='article'>
                <div className='title'>Intecje Łowiczki</div>
                <ul>
                    <li>Piątek 28.03 + Stanisław Ryszka </li>
                    <li>Niedziela 30.03 ++ Adam Władysława Huczek</li>
                    <li>Piątek 4.04 ++ Anna Dąbrowska, Zbigniew s.</li>
                    <li>Niedziela 6.04 
                    <ul>
                        <li>++ Czesław Ortman, Józef Anna rodzice</li>
                        <li>+ Mariusz Matla (od siostry Barbary z rodz.)</li>
                    </ul>
                    </li>
                    <li>Poniedziałek 7.04 O błog. Boże dla członkiń Róży Różańcowej, o powołania do Służby Bożej z naszej Parafii, za Ojca Świętego i Kościół</li>
                    <li>Wtorek 8.04 ++ Bronisław Władysława Lewańscy</li>
                    <li>Środa 9.04 + Józef Wolanin (od córki z mężem)</li>
                    <li>Piątek 11.04 + Wiesław Dąbrowski (od syna Adriana z rodz.)</li>
                    <li>Niedziela 13.04 ++ Stanisław Michalina Sermak, Stanisław s., Władysław Turza, rodzice</li>
                    <li>Niedziela 20.04 
                    <ul>
                        <li>++ Tadeusz Janina Brzeźniak</li>
                        <li>+ Anna Dąbrowska (od wnuka Artura z żoną i prawnukami)</li>
                    </ul>
                    </li>
                    </ul>
            </div>
            <Footer />
        </>
    )
}

export default IntencjeLowiczki